/** Same catalog as apps/api catalog-seed (IDs assigned at offline init). */
export type CatalogSeedRow = {
  key: string;
  name: string;
  tags: string[];
};

export const INGREDIENT_CATALOG: CatalogSeedRow[] = [
  { key: "shrimp", name: "Shrimp", tags: ["Seafood", "Protein", "Fresh", "Japanese"] },
  { key: "salmon", name: "Salmon", tags: ["Seafood", "Protein", "Rich", "Umami"] },
  { key: "chicken", name: "Chicken", tags: ["Meat", "Protein", "Rich", "American"] },
  { key: "beef", name: "Steak bites", tags: ["Meat", "Protein", "Rich", "Umami"] },
  { key: "tofu", name: "Tofu", tags: ["Tofu", "Protein", "Fresh", "Japanese"] },
  { key: "egg", name: "Farm Egg", tags: ["Egg", "Protein", "Rich", "French"] },
  { key: "black_beans", name: "Black beans", tags: ["Beans", "Protein", "Mexican"] },
  { key: "lentils", name: "Lentils", tags: ["Beans", "Protein", "Rich", "Mediterranean"] },
  { key: "pasta_shells", name: "Pasta shells", tags: ["Pasta", "Carb", "Italian"] },
  { key: "spaghetti", name: "Spaghetti", tags: ["Pasta", "Carb", "Italian"] },
  { key: "rice_white", name: "Jasmine rice", tags: ["Rice", "Carb", "Thai"] },
  { key: "naan_bread", name: "Garlic naan", tags: ["Bread", "Carb", "Indian"] },
  { key: "tortillas", name: "Corn tortillas", tags: ["Bread", "Carb", "Mexican"] },
  { key: "sourdough", name: "Sourdough loaf", tags: ["Bread", "Carb", "Fresh", "American"] },
  { key: "potato_roast", name: "Roast potato", tags: ["Potato", "Carb", "Rich"] },
  { key: "polenta_creamy", name: "Creamy polenta", tags: ["Carb", "Grain", "Italian", "Rich"] },
  { key: "tomatoes", name: "Heirloom tomatoes", tags: ["Vegetable", "Fresh", "Sweet", "Italian"] },
  { key: "arugula", name: "Arugula", tags: ["Leafy", "Fresh", "Vegetable", "Italian"] },
  { key: "shiitake", name: "Shiitake", tags: ["Vegetable", "Umami", "Japanese"] },
  { key: "corn_cob", name: "Sweet corn", tags: ["Vegetable", "Sweet", "American"] },
  { key: "zucchini", name: "Zucchini ribons", tags: ["Vegetable", "Fresh", "Mediterranean"] },
  { key: "bell_pepper", name: "Charred pepper", tags: ["Vegetable", "Smoky", "Mexican"] },
  { key: "parmesan", name: "Parmesan", tags: ["Dairy", "Rich", "Umami", "Italian"] },
  { key: "creme_fraiche", name: "Crème fraîche", tags: ["Dairy", "Rich", "French"] },
  { key: "cotija", name: "Cotija", tags: ["Dairy", "Rich", "Mexican"] },
  { key: "cream_coconut", name: "Coconut cream", tags: ["Dairy", "Rich", "Sweet", "Thai"] },
  { key: "lime", name: "Lime juice", tags: ["Citrus", "Fresh", "Sour", "Mexican"] },
  { key: "basil_leaf", name: "Basil bouquet", tags: ["Herb", "Fresh", "Italian"] },
  { key: "cilantro_bundle", name: "Cilantro", tags: ["Herb", "Fresh", "Mexican"] },
  { key: "ginger_knob", name: "Ginger", tags: ["Spicy", "Warm", "Fresh", "Thai"] },
  { key: "garlic_roast", name: "Roasted garlic", tags: ["Flavor", "Rich", "Umami"] },
  { key: "miso_white", name: "White miso", tags: ["Umami", "Flavor", "Japanese"] },
  { key: "gochugaru", name: "Korean chili flake", tags: ["Spicy", "Flavor", "Korean"] },
  { key: "harissa", name: "Harissa paste", tags: ["Spicy", "Flavor", "Mediterranean"] },
  { key: "maple_glaze", name: "Maple glaze", tags: ["Sweet", "Flavor", "American"] },
  { key: "chipotle_aioli", name: "Chipotle aioli", tags: ["Rich", "Spicy", "Mexican"] },
  { key: "brown_butter_sage", name: "Brown butter sage", tags: ["Rich", "Herb", "Italian"] },
  { key: "teriyaki", name: "Teriyaki drizzle", tags: ["Sweet", "Umami", "Japanese"] },
  { key: "lemon_curd", name: "Lemon curd", tags: ["Sweet", "Citrus", "Dessert", "French"] },
  { key: "mint_sprigs", name: "Mint leaves", tags: ["Herb", "Cool", "Fresh"] },
  { key: "sumac_pinch", name: "Sumac dust", tags: ["Sour", "Flavor", "Mediterranean"] },
  { key: "sesame_blend", name: "Toasted sesame", tags: ["Umami", "Flavor", "Japanese"] },
  { key: "smoked_paprika", name: "Smoked paprika", tags: ["Smoky", "Spicy"] },
  { key: "brown_sugar", name: "Brown sugar", tags: ["Sweet", "Warm"] },
  { key: "fish_sauce_nam_pla", name: "Nam pla splash", tags: ["Umami", "Flavor", "Thai"] },
];
